import HeaderRenderer from './HeaderRenderer/HeaderRenderer';
import headerRootQuery, { initialVariables as headerInitialVariables } from '../queries/headerRootQuery';

import MobileNavWrapperRenderer from './MobileNavWrapperRenderer/MobileNavWrapperRenderer';
import
    mobileNavWrapperRootQuery,
    { initialVariables as mobileNavWrapperInitialVariables } from '../queries/mobileNavWrapperRootQuery';

import FooterRenderer from './FooterRenderer/FooterRenderer';
import footerRootQuery, { initialVariables as footerInitialVariables } from '../queries/footerRootQuery';

export {
    HeaderRenderer,
    headerRootQuery,
    headerInitialVariables,

    MobileNavWrapperRenderer,
    mobileNavWrapperRootQuery,
    mobileNavWrapperInitialVariables,

    FooterRenderer,
    footerRootQuery,
    footerInitialVariables
};



// WEBPACK FOOTER //
// ./src/components/index.js